export function wordsLength(str) {
  const maxLength = 1000;
  const minLength = 500;

  // Remove espaços extras e divide o texto em palavras
  const words = str.trim().split(/\s+/);

  // Conta o número de palavras
  const wordCount = words.length;

  // Verifica se o número de palavras está dentro dos limites
  if (wordCount > maxLength || wordCount < minLength) {
    return false;
  }

  return true;
}